import React, { useEffect } from 'react';

import '../css/pages/aplicacion.css';

const Aplicacion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="op-body-contenedor">
      <div className="op-fondo">
        <label>Pol&iacute;tica de Privacidad</label>
        <span>
          Pol&iacute;ticas de Privacidad aplicable a los usuarios de la
          aplicaci&oacute;n "WUASHO"
        </span>
      </div>
      <div className="op-info">
        <p>
          Esta pol&iacute;tica de privacidad rige el uso de la aplicaci&oacute;n
          <strong> WUASHO</strong> para dispositivos móviles Android, creada por
          Soluciones OP.
        </p>
        <span>¿Qu&eacute; informaci&oacute;n recopilamos?</span>
        <p>
          La aplicaci&oacute;n no recopila informaci&oacute;n personal como
          nombre, apellidos, edad, fecha de nacimiento, etc. Utilizamos la
          informaci&oacute;n de seguimiento del rendimiento de la
          aplicaci&oacute;n proporcionada por Google para mejorarla. Esta
          aplicaci&oacute;n solo utiliza el sonido de su tel&eacute;fono Android
          para crear la alarma.
        </p>
        <span>Google Analytics</span>
        <p>
          Esta aplicaci&oacute;n utiliza Google Analytics para analizar
          c&oacute;mo la usas. Esto nos ayuda a mejorar este producto. Gracias a
          Google Analytics, sabemos cu&aacute;nto tiempo la usas, qu&eacute;
          tipo de dispositivo usas, d&oacute;nde vives y mucho m&aacute;s. Todo
          esto se utiliza para mejorar la aplicaci&oacute;n. M&aacute;s
          informaci&oacute;n sobre Google Analytics
        </p>
        <span>Anuncio</span>
        <p>
          La pol&iacute;tica de privacidad de Google Admob est&aacute;
          disponible aqu&iacute;:
          https://support.google.com/admob/answer/6128543?hl=es. Proveedores
          externos, incluido Google, utilizan cookies para mostrar anuncios
          basados ​​en las visitas anteriores de los usuarios a su sitio web.
        </p>
        <p>
          El uso de la cookie de DoubleClick por parte de Google y sus socios
          permite mostrar anuncios a sus usuarios seg&uacute;n sus visitas a sus
          sitios web u otros sitios web.
        </p>
        <p>
          Los usuarios pueden desactivar el uso de la cookie de DoubleClick para
          la publicidad basada en intereses visitando la configuraci&oacute;n de
          anuncios. (Alternativamente, puede indicar a los usuarios que
          desactiven el uso de cookies de un proveedor externo para la
          publicidad basada en intereses visitando aboutads.info).
        </p>
        <span>Contacto</span>
        <p>
          Para contactarnos, utilice el correo electrónico
          soporte@solucionesop.com
        </p>
      </div>
    </div>
  );
};

export default Aplicacion;
